import { GridApi } from 'ag-grid-community'
import { useCallback } from 'react'
import { exportExcel } from '../../../containers/BulkSheet/excel'

export const useExportExcel = (gridApi: GridApi): (() => void) => {
  const onExportExcel = useCallback(() => {
    const colIds = gridApi?.getColumns() ?? []
    if (!colIds || colIds.length === 0) return
    exportExcel({
      fileNamePrefix: 'unit_price_per_positions',
      gridApi,
      exportColIds: colIds.map(v => v.getColId()),
    })
  }, [gridApi])

  return onExportExcel
}
